import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./create-application-details-ec.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./create-application-details-ec.component.scss?ngResource";
import { ChangeDetectorRef, Component } from "@angular/core";
import { CreateApplicationDetailsEcConstants } from "./create-application-details-ec.constants";
import { CreateApplicationViewBaseComponent } from "../../../shared/create-application-view-base/create-application-view-base.component";
import { SharedConstants } from "../../../../shared/constants/shared.constants";
import { ApplicationCreateService } from "../../../shared/application-create.service";
import { AflaModuleStrategyService } from "../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { SelectedApplicationService } from "../../../../shared/services/selected-application/selected-application.service";
import { AppControllerService } from "../../../../app-controller.service";
import { CRUDOperation } from "../../../../shared/models/crud-operation-enum.model";
import { SearchApplicationsService } from "../../../../search-applications/shared/search-applications.service";
let CreateApplicationDetailsEcComponent = class CreateApplicationDetailsEcComponent extends CreateApplicationViewBaseComponent {
    applicationCreateService;
    aflaModuleStrategyService;
    selectedApplicationService;
    appController;
    changeDetectorRefs;
    searchApplicationsService;
    // Labels
    descriptionLabel = CreateApplicationDetailsEcConstants.DESCRIPTION_LABEL;
    applicationTypeLabel = CreateApplicationDetailsEcConstants.APPLICATION_TYPE_LABEL;
    whoIsApplyingLabel = CreateApplicationDetailsEcConstants.WHO_IS_APPLYING_LABEL;
    descriptionOfProposedWorkLabel = CreateApplicationDetailsEcConstants.DESCRIPTION_OF_PROPOSED_WORK_LABEL;
    descriptionOfProposedWorkNote = CreateApplicationDetailsEcConstants.DESCRIPTION_OF_PROPOSED_WORK_NOTE;
    phaseLabel = CreateApplicationDetailsEcConstants.PHASE_LABEL;
    conventionalPrepaidLabel = CreateApplicationDetailsEcConstants.CONVENTIONAL_PREPAID_LABEL;
    estimatedCapacityLabel = CreateApplicationDetailsEcConstants.ESTIMATED_CAPACITY_LABEL;
    // Form controls
    detailsFormGroupName = CreateApplicationDetailsEcConstants.DETAILS_FORM_GROUP_NAME;
    descriptionFormControlName = CreateApplicationDetailsEcConstants.DESCRIPTION_FORM_CONTROL_NAME;
    applicationTypeFormControlName = CreateApplicationDetailsEcConstants.APPLICATION_TYPE_FORM_CONTROL_NAME;
    applicantTypeFormControlName = CreateApplicationDetailsEcConstants.APPLICANT_TYPE_FORM_CONTROL_NAME;
    descriptionOfProposedWorkFormControlName = CreateApplicationDetailsEcConstants.DESCRIPTION_OF_PROPOSED_WORK_FORM_CONTROL_NAME;
    phaseFormControlName = CreateApplicationDetailsEcConstants.PHASE_FORM_CONTROL_NAME;
    paymentTypeControlName = CreateApplicationDetailsEcConstants.PAYMENT_TYPE_CONTROL_NAME;
    estimatedCapacityControlName = CreateApplicationDetailsEcConstants.ESTIMATED_CAPACITY_FORM_CONTROL_NAME;
    // constants
    validationMessages = CreateApplicationDetailsEcConstants.VALIDATION_MESSAGES;
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    removeLabel = SharedConstants.REMOVE_LABEL;
    // variables
    detailsForm;
    applicationTypes = [];
    applicantTypes = [];
    phases = [];
    conventionalPrepaidOptions = [];
    selectedApplicationEcSubscription;
    constructor(applicationCreateService, aflaModuleStrategyService, selectedApplicationService, appController, changeDetectorRefs, searchApplicationsService) {
        super(applicationCreateService, aflaModuleStrategyService, selectedApplicationService, searchApplicationsService);
        this.applicationCreateService = applicationCreateService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.selectedApplicationService = selectedApplicationService;
        this.appController = appController;
        this.changeDetectorRefs = changeDetectorRefs;
        this.searchApplicationsService = searchApplicationsService;
    }
    ngOnInit() {
        this.initForm();
        this.loadLookups();
        this.getMetadata();
        this.subscribeToSelectedApplication();
        this.subscribeToCheckFormValidity();
    }
    loadMetadata(stepMeta) {
    }
    subscribeToSelectedApplication() {
        this.selectedApplicationEcSubscription = this.selectedApplicationService.$selectedApplication.subscribe((application) => {
            if (application) {
                this.populateForm(application);
            }
        });
    }
    initForm() {
        this.detailsForm = this.aflaModuleStrategyService.form.get("detailsForm");
        this.detailsForm.enable();
    }
    populateForm(application) {
        if (application && application.appId > 0)
            this.detailsForm.markAsTouched();
        else
            return;
        const applicationType = this.applicationTypes.find(x => x.code === application.applicationType);
        const applicantType = this.applicantTypes.find(x => x.code === application.applicantType);
        const phase = this.phases.find(x => x.code === application.phase);
        const paymentType = this.conventionalPrepaidOptions.find(x => x.code === application.paymentType);
        this.detailsForm.get(this.descriptionFormControlName).setValue(application.description);
        this.detailsForm.get(this.applicationTypeFormControlName).setValue(applicationType);
        this.detailsForm.get(this.applicantTypeFormControlName).setValue(applicantType);
        this.detailsForm.get(this.descriptionOfProposedWorkFormControlName).setValue(application.descriptionOfProposedWork);
        this.detailsForm.get(this.phaseFormControlName).setValue(phase);
        this.detailsForm.get(this.estimatedCapacityControlName).setValue(application.estimatedCapacity);
        this.detailsForm.get(this.paymentTypeControlName).setValue(paymentType);
    }
    loadLookups() {
        const params = {
            $filter: `(moduleId eq ${this.appController.selectedModuleID}) and ((name eq '${CreateApplicationDetailsEcConstants.APPLICATION_TYPE_LOOKUP_NAME}' and deleted eq false) or (name eq '${CreateApplicationDetailsEcConstants.APPLICANT_TYPE_LOOKUP_NAME}' and deleted eq false) or (name eq '${CreateApplicationDetailsEcConstants.PHASE_LOOKUP_NAME}' and deleted eq false) or (name eq '${CreateApplicationDetailsEcConstants.CONVENTIONAL_PREPAID_LOOKUP_NAME}' and deleted eq false))`
        };
        this.applicationCreateService
            .getLookupsObservable(params).subscribe({
            next: (response) => this.onGetLookupsCompleted(response),
            error: (error) => {
                this.appController.handleServerErrorMessage(CreateApplicationDetailsEcConstants.STEP_TITLE, error, CRUDOperation.Get);
            }
        });
    }
    onGetLookupsCompleted(response) {
        const applicationTypes = [];
        const applicantTypes = [];
        const phases = [];
        const conventionalPrepaid = [];
        if (response && response.value.length > 0) {
            response.value.forEach(item => {
                if (item.name === `${CreateApplicationDetailsEcConstants.APPLICATION_TYPE_LOOKUP_NAME}`) {
                    applicationTypes.push(JSON.parse(item.content));
                }
                if (item.name === `${CreateApplicationDetailsEcConstants.APPLICANT_TYPE_LOOKUP_NAME}`) {
                    applicantTypes.push(JSON.parse(item.content));
                }
                if (item.name === `${CreateApplicationDetailsEcConstants.PHASE_LOOKUP_NAME}`) {
                    phases.push(JSON.parse(item.content));
                }
                if (item.name === `${CreateApplicationDetailsEcConstants.CONVENTIONAL_PREPAID_LOOKUP_NAME}`) {
                    conventionalPrepaid.push(JSON.parse(item.content));
                }
            });
            applicationTypes.sort((a, b) => a.value.localeCompare(b.value));
            applicantTypes.sort((a, b) => a.value.localeCompare(b.value));
            phases.sort((a, b) => a.value.localeCompare(b.value));
            conventionalPrepaid.sort((a, b) => a.value.localeCompare(b.value));
            this.aflaModuleStrategyService.lookups.set(`${CreateApplicationDetailsEcConstants.APPLICATION_TYPE_LOOKUP_NAME}`, applicationTypes);
            this.aflaModuleStrategyService.lookups.set(`${CreateApplicationDetailsEcConstants.APPLICANT_TYPE_LOOKUP_NAME}`, applicantTypes);
            this.aflaModuleStrategyService.lookups.set(`${CreateApplicationDetailsEcConstants.PHASE_LOOKUP_NAME}`, phases);
            this.aflaModuleStrategyService.lookups.set(`${CreateApplicationDetailsEcConstants.CONVENTIONAL_PREPAID_LOOKUP_NAME}`, conventionalPrepaid);
            this.applicationTypes = applicationTypes;
            this.applicantTypes = applicantTypes;
            this.phases = phases;
            this.conventionalPrepaidOptions = conventionalPrepaid;
            this.populateForm(this.selectedApplication);
            this.changeDetectorRefs.detectChanges();
        }
    }
    subscribeToCheckFormValidity() {
        this.applicationCreateService.$markStepFormGroupAsTouchedSubscription.subscribe({
            next: (formGroupName) => {
                if (formGroupName && this.detailsForm && formGroupName === this.detailsFormGroupName) {
                    this.detailsForm.markAllAsTouched();
                    this.changeDetectorRefs.markForCheck();
                }
            }
        });
    }
    static ctorParameters = () => [
        { type: ApplicationCreateService },
        { type: AflaModuleStrategyService },
        { type: SelectedApplicationService },
        { type: AppControllerService },
        { type: ChangeDetectorRef },
        { type: SearchApplicationsService }
    ];
};
CreateApplicationDetailsEcComponent = __decorate([
    Component({
        selector: "app-create-application-details-ec",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], CreateApplicationDetailsEcComponent);
export { CreateApplicationDetailsEcComponent };
